module.exports = __webpack_public_path__ + "static/media/CovetrusPulse.c98bbe7a.png";